import '../style.scss';

import { initScroll } from './scroll.js';
import { initDropdownTouch } from './dropdown-touch.js';
import { initPreloader } from './preloader.js';
import { initQuantityButtons } from './quantity-buttons.js';

initScroll();
initDropdownTouch();
initPreloader();
initQuantityButtons();
